import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpService } from '../../../../services/http/http.service';
import { createApiUrl } from '../../../../utils/functions';
import { InspectionSetting } from './model/inspection-setting.model';

@Injectable()
export class InspectionSettingService extends HttpService<InspectionSetting> {
  public readonly route = 'inspection-setting';

  async getForObject(objectId: number): Promise<InspectionSetting[]> {
    const url = createApiUrl('object', objectId, 'inspection-setting');

    return firstValueFrom(this.http.get<InspectionSetting[]>(url, this.options));
  }

  async getForProject(projectId: number): Promise<InspectionSetting[]> {
    const url = createApiUrl('project', projectId, 'inspection-setting');

    return firstValueFrom(this.http.get<InspectionSetting[]>(url, this.options));
  }

  async createForObject(
    objectId: number,
    inspectionSetting: Omit<InspectionSetting, 'id'>,
  ): Promise<InspectionSetting> {
    const url = createApiUrl('object', objectId, 'inspection-setting');

    return firstValueFrom(this.http.post<InspectionSetting>(url, inspectionSetting, this.options));
  }

  async createForProject(
    projectId: number,
    inspectionSetting: Omit<InspectionSetting, 'id'>,
  ): Promise<InspectionSetting> {
    const url = createApiUrl('project', projectId, 'inspection-setting');

    return firstValueFrom(this.http.post<InspectionSetting>(url, inspectionSetting, this.options));
  }

  async deleteForObject(objectId: number, inspectionSettingId: string): Promise<boolean> {
    const url = createApiUrl('object', objectId, 'inspection-setting', inspectionSettingId);

    await firstValueFrom(this.http.delete(url, this.options));

    return true;
  }

  async deleteForProject(projectId: number, inspectionSettingId: string): Promise<boolean> {
    const url = createApiUrl('project', projectId, 'inspection-setting', inspectionSettingId);

    await firstValueFrom(this.http.delete(url, this.options));

    return true;
  }

  async getForObjectAndCategory(objectId: number, caseCategoryId: number): Promise<InspectionSetting | null> {
    const url = createApiUrl('object', objectId, 'inspection-setting-for-category', caseCategoryId);

    return firstValueFrom(this.http.get<InspectionSetting | null>(url, this.options));
  }

  async getForProjectAndCategory(projectId: number, caseCategoryId: number): Promise<InspectionSetting | null> {
    const url = createApiUrl('project', projectId, 'inspection-setting-for-category', caseCategoryId);

    return firstValueFrom(this.http.get<InspectionSetting | null>(url, this.options));
  }
}
